import React, { useEffect } from 'react';

export default function TradingViewWidget({ symbol = "RELIANCE", theme = "light" }) {
    const containerId = "tradingview_widget";

    useEffect(() => {
        // Determine full symbol string (e.g., "NSE:RELIANCE")
        // If symbol already has exchange prefix (e.g. "BSE:TCS"), use it. Otherwise default to BSE (NSE often restricted).
        const fullSymbol = symbol.includes(":") ? symbol : `BSE:${symbol}`;

        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/tv.js';
        script.async = true;
        script.onload = () => {
            if (window.TradingView) {
                new window.TradingView.widget({
                    autosize: true,
                    symbol: fullSymbol,
                    interval: "D",
                    timezone: "Asia/Kolkata",
                    theme: theme,
                    style: "1",
                    locale: "in",
                    toolbar_bg: "#f1f3f6",
                    enable_publishing: false,
                    allow_symbol_change: true,
                    container_id: containerId,
                    withdateranges: true,
                    hide_side_toolbar: false, // This enables the drawing toolbar
                    studies: [
                        "MASimple@tv-basicstudies",
                        "RSI@tv-basicstudies"
                    ]
                });
            }
        };
        document.head.appendChild(script);

        return () => {
            // Check if script is still child before removing to avoid errors
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
            // Widget Iframe cleanup
            const container = document.getElementById(containerId);
            if (container) container.innerHTML = '';
        };
    }, [symbol, theme]);

    return (
        <div className='tradingview-widget-container' style={{ height: "100%", width: "100%" }}>
            <div id={containerId} style={{ height: "100%", width: "100%" }} />
        </div>
    );
}
